import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';

function EmailVerifier() {
  const API_URL = process.env.REACT_APP_API_URL;
  
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  
  const [status, setStatus] = useState('verifying'); // 'verifying', 'success', 'error'
  const [message, setMessage] = useState('Trwa weryfikacja Twojego konta...');

  // Pobieramy parametr "token" z adresu URL: /weryfikacja?token=XXXX
  const token = searchParams.get('token');

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setMessage('Brak prawidłowego tokenu weryfikacyjnego.');
      return;
    }

    // Wysyłamy token na backend w celu aktywacji konta
    axios.post(`${API_URL}/users/verify-token`, { token })
      .then(response => {
        setStatus('success');
        setMessage('Twoje konto zostało pomyślnie aktywowane!');
        
        // Po 3 sekundach automatycznie przenieś użytkownika do logowania
        setTimeout(() => {
          navigate('/logowanie');
        }, 5000);
      })
      .catch(error => {
        setStatus('error');
        setMessage(error.response?.data?.message || 'Link wygasł lub jest nieprawidłowy.');
      });
  }, [token, navigate]);

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '80vh',
      textAlign: 'center',
      fontFamily: 'sans-serif'
    }}>
      <div style={{
        padding: '40px',
        borderRadius: '12px',
        border: '1px solid #e2e8f0',
        boxShadow: '0 4px 20px rgba(0,0,0,0.05)',
        maxWidth: '400px'
      }}>
        {status === 'verifying' && <div style={{ fontSize: '2.5rem' }}>⏳</div>}
        {status === 'success' && <div style={{ fontSize: '2.5rem' }}>✅</div>}
        {status === 'error' && <div style={{ fontSize: '2.5rem' }}>❌</div>}
        
        <h2 style={{ margin: '20px 0 10px 0' }}>Weryfikacja e-mail</h2>
        <p style={{ color: '#64748b', lineHeight: '1.5' }}>{message}</p>
        
        {status === 'success' && (
          <p style={{ fontSize: '0.85rem', color: '#94a3b8' }}>Za chwilę nastąpi przekierowanie...</p>
        )}
      </div>
    </div>
  );
}

export default EmailVerifier;